<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M10 13.75V11.5" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
    <path d="M14.5 4.75H16C16.4142 4.75 16.75 5.08579 16.75 5.5V6.25C16.75 7.49264 15.7427 8.5 14.5 8.5" 
    stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
    <path d="M5.5 4C5.5 3.58579 5.83579 3.25 6.25 3.25H13.75C14.1642 3.25 14.5 3.58579 14.5 4V7C14.5 9.48527 12.4853 11.5 10 11.5C7.51472 11.5 5.5 9.48527 5.5 7V4Z" 
    stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
    <path d="M6.25 14.5C6.25 14.0858 6.58579 13.75 7 13.75H13C13.4142 13.75 13.75 14.0858 13.75 14.5V16C13.75 16.4142 13.4142 16.75 13 16.75H7C6.58579 16.75 6.25 16.4142 6.25 16V14.5Z" 
    stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
    <path d="M5.5 4.75H4C3.58579 4.75 3.25 5.08579 3.25 5.5V6.25C3.25 7.49264 4.25736 8.5 5.5 8.5" 
    stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'TrophyIcon',
  props: {
    width: {
      type: Number,
      default: 20,
    },
    height: {
      type: Number,
      default: 20,
    }
  }
}
</script>

<style scoped></style>